module.exports = __webpack_public_path__ + "static/media/clydesdale_bank.44a63484.jpg";